import React from 'react';
import { useSelector } from 'react-redux';
import { IS_CLIENT, HOSTNAME } from '@constants';
import { MainHead } from './Main-Head';
import { ui } from './ui';

export const CabinetLayout = ({ title, children }) => {
  const { locale } = useSelector((state) => state.settings);

  const onLoadUI = () => {
    if (IS_CLIENT) {
      ui.connectTranslations();
      ui.initObserver({ locale });
      ui.initGallery({ locale });
    }
  };

  return (
    <>
      <MainHead title={title} />
      <main>{children}</main>
      <div id="modal" />
      <div id="store" />
      <script onLoad={onLoadUI()} src={`https://ui.${HOSTNAME}/static/js/site.js`} />
    </>
  );
};
